import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css"; // Bootstrap styles
import ThemeProvider from './components/ThemeProvider';
import { GlobalStyles } from './styles/GlobalStyles';
import { Provider } from "react-redux";
import { persistor, store } from "./redux/slices/store";
import { PersistGate } from "redux-persist/integration/react";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <GlobalStyles />
      <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
      <App />
      </PersistGate>
      </Provider>
    </ThemeProvider>
  </React.StrictMode>
);
